import React, { useCallback } from 'react';
import { useToast } from '@shared/components/toast';
import { ValidateFilesFn } from '@shared/scenes/upload/hooks';
import { MBSelectAttachmentType } from '@shared/scenes/upload/util/types';
import { useDispatch, useSelector } from '@shared/store';
import { i18n } from '@shared/util/i18n';
import { MBPlusButton } from '../components/plusButton';
import * as Actions from '../store/actions';
import { MAX_CHAT_ATTACHMENTS } from '../store/reducer';

interface Props {
  draftId: string;
  hideUrgent?: boolean;
  validateUploads: ValidateFilesFn;
}

export function MBChatInputPlusButton({ draftId, hideUrgent, validateUploads }: Props) {
  const dispatch = useDispatch();
  const toast = useToast();
  const urgent = useSelector(state => !!state.chatInput.urgentFromDraftId[draftId]);

  const onLimitExceeded = useCallback(
    (rejectedCount: number) => {
      toast.show({
        style: 'warning',
        message: i18n('chat.input.attachmentLimit.exceeded', {
          max: MAX_CHAT_ATTACHMENTS,
          count: rejectedCount,
        }),
        duration: 4000,
      });
    },
    [toast],
  );

  const onShowGIFModal = useCallback(
    () => Actions.showGIFModal(draftId)(dispatch),
    [dispatch, draftId],
  );
  const onSelectAttachment = useCallback(
    (type: MBSelectAttachmentType) =>
      dispatch(Actions.selectAttachment(type, draftId, validateUploads, onLimitExceeded)),
    [dispatch, draftId, validateUploads, onLimitExceeded],
  );
  const onSendAsUrgent = useCallback(
    () => Actions.enableUrgent(draftId)(dispatch),
    [dispatch, draftId],
  );
  const onRemoveSendAsUrgent = useCallback(
    () => Actions.disableUrgent(draftId)(dispatch),
    [dispatch, draftId],
  );
  return (
    <MBPlusButton
      draftId={draftId}
      urgent={urgent}
      hideUrgent={hideUrgent}
      onShowGIFModal={onShowGIFModal}
      onSelectAttachment={onSelectAttachment}
      onSendAsUrgent={onSendAsUrgent}
      onRemoveSendAsUrgent={onRemoveSendAsUrgent}
    />
  );
}
